const isDev = false;
const isInternation = false;
const isTest = true;
//国内域名是api.diva-ai.cn
//国际域名是api.diva-ai.net
export const API_URL = 
   isTest? 'https://api-competition-test.diva-ai.cn/api'
  : isDev? 'http://localhost:3000/api'
  : isInternation ? 'https://api.diva-ai.net/api' : 'https://api.diva-ai.cn/api';

export const STATIC_URL = 
   isTest? 'https://api-competition-test.diva-ai.cn'
  : isDev? 'http://localhost:3000'
  : isInternation ? 'https://api.diva-ai.net' : 'https://api.diva-ai.cn';




